export default __webpack_public_path__ + "static/media/western-party.ae67ccfe.jpg";